import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colorTokens.content.onDark};
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  height: 44px;
  padding: 0 ${({ theme }) => theme.space["space-4"]};
  background-color: ${({ theme }) => theme.colorTokens.background.layer};
  border-bottom: 1px solid ${({ theme }) => theme.colorTokens.border.default};
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
`;

export const ListItem = styled.li`
  display: flex;
  flex-direction: column;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colorTokens.border.default};
  }
`;
